<template>
  <div>
    <!-- 反选组件 -->
    <TreeRightMenu
      ref="treeRightMenu"
      :title="rightMenuTitle"
      @confirm="confirm"
      @editModel="editModel"
    ></TreeRightMenu>
    <!-- 模型详情 -->
    <MapModal
      class="mModel newModelPosition hierarchy2"
      :modalNode="modalNode"
      :title="bimModelDetails.title"
      :id="bimModelDetails.id"
      :close="hideRightMenu"
      :class="{
        'y-2': propertyListShow,
      }"
      style="--hierarchyY: 380px"
    ></MapModal>
    <!-- 编辑模型 -->
    <MapModal
      class="mModel newModelPosition hierarchy2"
      title="模型编辑"
      id="modalEditNode"
      :modalNode="modalEditNode"
      :close="modalEditClose"
      :class="{
        'y-2': propertyListShow,
      }"
      style="--hierarchyY: 380px"
    >
      <template slot="content">
        <div class="content settings">
          <div>
            <p class="titleClass">通用属性</p>
            <div class="contentParentClass">
              <div class="flexChildren" style="justify-content: flex-start;">
                <p style="padding-right: 13px;">颜色</p>
                <el-color-picker
                  v-model="form.modalColor"
                  style="padding-left: 7px;"
                  show-alpha
                  :predefine="predefineColors"
                  @change="colorChange"
                ></el-color-picker>
              </div>
              <div class="flexChildren" style="justify-content: space-between;">
                <p>透明度</p>
                <el-slider
                  v-model="form.opacity"
                  :min="0"
                  :max="1"
                  :step="0.1"
                  @input="opacityInput"
                ></el-slider>
              </div>
            </div>
          </div>
          <div>
            <div class="flexRight btns">
              <el-button @click="clearColor" type="danger">清除颜色</el-button>
              <el-button @click="modalEditClose" type="primary">关闭</el-button>
            </div>
          </div>
        </div>
      </template>
    </MapModal>
  </div>
</template>
<script>
const TreeRightMenu = () =>
  import("@/components/common/treeRightMenu/Index.vue");
const MapModal = () => import("@/components/common/mapModal/Index");
import screenplayFn from "@/components/tables/program/screenplayFn.js";
import { getProjectBimModel } from "@/api/api";
export default {
  name: "model-details",
  components: {
    TreeRightMenu,
    MapModal,
  },
  computed: {
    rightMenuTitle: function() {
      let name = this.name;
      return [
        {
          title: `编辑模型`,
          key: "Edit",
        },
        {
          title: `查看${name}详情`,
          key: "Details",
        },
      ];
    },
    bimModelDetails: function() {
      let name = this.name;
      return {
        title: `${name}模型详情`,
        id: "bimModelDetails", // id和ref使用的同一个
      };
    },
  },
  props: ["propertyListShow"],
  data() {
    return {
      name: "",
      id: "",
      modelUid: "",
      modalNode: {
        bimModelDetails: {
          show: false, // 默认展示
          loading: true, // 加载loading
          // offset: {
          //   // 默认弹出层偏移
          //   y: -750,
          //   x: 55,
          //   // unit: "px", // 默认px
          // },
          height: "550px", // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          // 模态框中心配置
          content: {
            type: "tree", // 模态框内容类型 关键
            id: "bimModelDetailsTree", // id和ref使用的同一个
            name: "title", // 树的展示字段 默认name
            expand: false,
            expandClick: true,
            i_icon: {
              // level_1: "el-icon-star-off",
              // level_2: "el-icon-s-goods",
              // level_3: "el-icon-video-pause",
            },
            // 树形Json 后台接受的具体数据 核心
            treeDataJson: [],
            search: {
              //不需要搜索直接不传
              // type: "", //暂时无用 预留字段 后期配置 判断是否是ajax
              keywords: "title", // 搜素配置关键字 默认是name
              // filterNode: this.filterNode, // 搜索的逻辑 可以自己配置
            },
            // nodeClick 事件绑定
            nodeClick: this.nodeClick,
          },
        },
      },
      modalEditNode: {
        modalEditNode: {
          show: false, // 默认展示
          loading: false, // 加载loading
          height: "230px", // 配置模态框中心高度
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
        },
      },
      form: {
        modalColor: null,
        opacity: 1,
      },
      predefineColors: [
        //颜色选择器
        "#ffffff",
        "#c71585",
        "#ff4500",
        "#ffd700",
        "#55e8a2",
        "#1ba784",
        "#00ced1",
        "#1e90ff",
        "#9932cd",
        "#000000",
      ],
    };
  },
  watch: {
    // form: {
    //   deep: true,
    //   handler(newVal, oldVal) {
    //     console.log(newVal, oldVal);
    //     let { modalColor, transparency } = newVal;
    //     screenplayFn;
    //     // if(modalColor){
    //     // }
    //   },
    // },
  },
  mounted() {},
  methods: {
    // 关闭模态框的方法
    hideRightMenu() {
      // 判断 右键菜单是否存在
      if (
        this.$refs.treeRightMenu &&
        this.modalNode &&
        this.modalNode.bimModelDetails.show
      ) {
        // 重新渲染模型
        let model = this.getModel();
        if (model) model.style = undefined;
        // 关闭 右键菜单
        this.$refs.treeRightMenu.menuVisibleHide();
        if (this.modalNode) this.modalNode.bimModelDetails.show = false;
      }
    },
    // 右键选择菜单事件
    rightClick(MouseEvent, object, Node, element) {
      // 重新渲染模型
      let model = this.getModel();
      if (model && this.modalNode.bimModelDetails.show) model.style = undefined;
      // 获取当前操作模型的id 很重要
      this.id = object.id;
      // 给右键菜单组件传参
      this.$refs.treeRightMenu.rightClick(MouseEvent, object, Node, element);
      // 给name 赋值
      this.name = object.title;
    },
    // 防抖 1秒 点击树节点的方法
    nodeClick: _.debounce(function(e) {
      // 渲染模型
      console.log(e.bimModel.fullName);
      let model = this.getModel();
      model.style = (event) => {
        // console.log(event.feature.getProperty());
        if (
          event.feature.getProperty("name").indexOf(e.bimModel.fullName) != -1
        ) {
          return "rgba(0,255,255,1)";
        }
        return "rgba(255,255,255,0.7)";
      };
    }, 400),
    // 初始化
    confirm(e) {
      if (this.modalNode) this.modalNode.bimModelDetails.show = true;
      let model = this.getModel();
      console.log(model);
      let projectId = window.sessionStorage.getItem("nowProjectId");
      getProjectBimModel({
        projectId,
        EMBSId: this.id,
      })
        .then((data) => {
          this.modalNode.bimModelDetails.loading = false;
          this.modalNode.bimModelDetails.content.treeDataJson =
            data.data.data.dataList;
        })
        .catch((err) => {
          this.$alert("网络不佳，请求错误！！", "出错提示", {
            type: "error",
          });
        });
    },

    // 编辑
    editModel() {
      let model = this.getModel();
      model.closeHighlight();
      this.form.opacity = model.opacity;
      if (model.style) {
        this.form.opacity = parseFloat(
          this.rgbaNum(model.style.color.conditions[0][1], 3)
        );
        this.form.modalColor = model.style.color.conditions[0][1];
      }

      if (this.modalEditNode) this.modalEditNode.modalEditNode.show = true;
    },
    // 通过id获取模型
    getModel() {
      let model;
      if (this.id != "") {
        this.modelUid = viewShed.inquire("modelArray", "modelId", this.id)?.uid;
        model = this.$GLOBAL.map.getLayerById(this.modelUid);
      }
      return model;
    },
    // 获取rgba颜色值
    rgbaNum(rgba, index) {
      let val = rgba.match(/(\d(\.\d+)?)+/g);
      return val[index];
    },
    // 颜色变化
    colorChange(e) {
      this.form.opacity = parseFloat(this.rgbaNum(e, 3));
      this.updateModelColors();
    },
    opacityInput(e) {
      let { modalColor } = this.form;
      if (modalColor && modalColor != "") {
        this.form.modalColor = `rgba(${this.rgbaNum(
          modalColor,
          0
        )},${this.rgbaNum(modalColor, 1)},${this.rgbaNum(modalColor, 2)},${e})`;
      }
      this.updateModelColors();
    },
    // 更新模型颜色
    updateModelColors(e) {
      let model = this.getModel();
      if (model) {
        let { modalColor, opacity } = this.form;
        let currentLayerId = window.sessionStorage.getItem("currentLayerId");

        if (modalColor && modalColor != "") {
          screenplayFn.model.overallStaining(modalColor, model.options.modelId);
        } else {
          screenplayFn.model.opacity(opacity, model.options.modelId);
        }
      }
    },
    clearColor() {
      let model = this.getModel();
      this.form.modalColor = null;
      this.form.opacity = 1;
      this.opacityInput(1);
      model.style = undefined;
    },
    modalEditClose() {
      if (this.modalEditNode) this.modalEditNode.modalEditNode.show = false;
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/index.scss";
@import "../../../assets/scss/box.scss";

#modalEditNode {
  .el-input {
    @include input_select(185, 32);
  }
  .el-slider {
    padding-left: 14px;
    display: inline-block;
    width: calc(100% - 38px);
    .el-slider__runway {
      display: inline-block;
      width: 100%;
      height: 6px;
      margin: 6px 0;
      @include background_color("t_color_op1");
      border-radius: 3px;
      .el-slider__button {
        @include border_color("slide_color_op1");
      }

      .el-slider__bar {
        @include background_color("slide_color_op1");
      }
    }
  }
  .widthImportant .el-input__inner {
    width: 91px !important;
  }
  .widthImportantFile .el-input__inner {
    width: 91px !important;
  }
  .widthImportantFile.el-input {
    margin-right: 13px !important;
    width: 91px !important;
  }

  @include switch_base();
  .el-switch {
    width: 116px;
    margin: 0;
    .el-switch__label {
      width: 28px;
      span {
        width: 28px;
        font-size: 11px;
      }
      &.el-switch__label--left {
        margin-right: 5px;
      }
      &.el-switch__label--right {
        margin-left: 5px;
      }
    }
    .el-switch__core {
      width: 40px !important;
      @include lheight(20);
      margin: 0 5px;
    }
  }
  .btns {
    margin-bottom: 12px;
    @include button_primary();
    @include button_default();
  }
  .el-color-picker {
    /* height: 26px !important; */
    height: 20px !important;
    line-height: 20px !important;
    width: 20px;
    padding: 0;

    .el-color-picker__trigger {
      border: none;
      height: 20px !important;
      line-height: 20px !important;
      width: 20px;
      padding: 0;
      .el-color-picker__color {
        border: none;
      }
      span.el-icon-arrow-down {
        // display: none;
      }
    }
  }

  // .el-select-dropdown {
  //   font-size: 12px !important;
  //   padding: 0 10px !important;
  //   height: 28px !important;
  //   line-height: 28px !important;
  //   overflow: hidden !important;
  //   width: calc(100% - 6px) !important;
  //   border-radius: 3px 3px !important;
  // }
  // // .el-scrollbar
  // // .el-select-dropdown__wrap
  // // .el-scrollbar__view
  // // .el-select-dropdown__item
  input.el-input__inner {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    background: none;
    padding: 0 10px;
    font-size: 14px;
    height: 36px !important;
    line-height: 36px;
    color: rgba(255, 255, 255, 0.9) !important;
  }
  .el-radio {
    white-space: break-spaces;
    word-break: break-all;
    .el-radio__input {
      line-height: 18px;
      .el-radio__inner {
        margin: 0 3px 0 0;
        @include background_color("t_color3_op2");
        &::after {
          /* 取消选中状态单选框中间的小圆点显示 */
          display: none;
        }
        &:hover {
          @include border_color("t_color1_op1");
        }
      }
      &.is-checked {
        .el-radio__inner {
          // @include border_color('t_color1_op1');
          // @include background_color('t_color1_op1');
          @include border_color("th_color_op1");
          @include background_color("t_color1_op2");
        }
      }
    }
    .el-radio__label {
      padding-left: 2px;
      font-size: 12px !important;
      color: white;
    }
    &.is-checked {
      .el-radio__label {
        @include font_color("t_color_op1");
      }
      .el-radio__inner {
        background-color: #2281b2 !important;
        // @include background_color("t_color1_op1");
      }
    }
  }

  .submitBtn {
    display: flex;
    flex-direction: inherit !important;
    justify-content: flex-end;
    padding-left: 169px !important;
    padding-top: 10px !important;
    margin-bottom: 0px !important;
    margin-top: 0px !important;
  }
  .el-radio-group {
    margin-top: 0px !important;
  }
  .changeWayDivStyle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .changeWayDivStyle .el-radio {
    padding-top: 0px !important;
  }
  .changeWay {
    margin-bottom: 18px !important;
  }
  .changeWay .el-form-item__label {
    padding-bottom: 64px !important;
  }
  .content {
    padding: 15px;
    display: flex;
    flex-direction: column;

    p {
      margin: 0px !important;
      color: #ffffff;
    }
    .titleClass {
      font-weight: 800;
      color: #ffffff;
      font-size: 13px;
    }
    .flexRight {
      width: auto;
      display: flex;
      padding: 40px 0px 0px;
      margin-right: -16px;
      align-items: center !important;
      justify-content: right !important;
    }
    .contentParentClass {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .flexChildren {
        justify-content: space-around;
        display: flex;
        align-items: center;
        padding: 5px 0px;
        p {
          flex-shrink: 0;
          // flex: 1;
          min-width: 100px;
          text-align: right;
          padding-right: 15px;
          font-size: 13px;
        }
        .OptimizationDegreeCss {
          display: flex;
          align-items: center;
          padding-right: 55px;
          p {
            text-align: left;
            min-width: 40px !important;
            padding-right: 10px;
          }
          .el-input {
            width: 75px !important;
          }
          .el-input__inner {
            width: 75px !important;
          }
        }
      }
    }
  }

  .el-form-item__label {
    color: rgba(255, 255, 255, 0.9) !important;
  }
  .el-radio__label {
    color: rgba(255, 255, 255, 0.9) !important;
  }
  .spanClass {
    color: #ffffff;
    flex-shrink: 0;
    text-align: right;
    padding-right: 15px;
    font-size: 13px;
    line-height: 32px;
    height: 32px;
  }
  .el-color-dropdown__btns {
    .el-input__inner {
      line-height: 28px !important;
      height: 28px !important;
      color: #606266 !important;
    }
  }

  .selectStyle {
    font-size: 12px;
    padding: 0 10px;
    height: 28px;
    line-height: 28px;
    overflow: hidden;
    width: 100%;
    border-radius: 3px 3px;
  }
  .selectStyle.el-select-dropdown__item.selected {
    background-color: rgba(42, 183, 255, 0.9) !important;
    color: #ffffff;
    font-weight: 700;
  }
  .selectStyle.el-select-dropdown__item:hover {
    background-color: rgba(42, 183, 255, 0.9) !important;
    color: #ffffff;
  }
  .el-button--danger {
    white-space: nowrap;
    cursor: pointer;
    -webkit-appearance: none;
    text-align: center;
    box-sizing: border-box;
    outline: 0;
    transition: 0.1s;
    font-weight: 500;
    font-size: 14px;
    border-radius: 4px;
    height: 28px;
    line-height: 28px;
    padding: 0 16px;
    margin: 6px 16px 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      font-size: 12px;
      display: block;
    }
  }
}
</style>
